import styles from "./articleListingPanel.module.scss"
import DynamicCard from "../../../components/dynamicCard/dynamicCard";
function Col2FiftyFifty({articles}){ 
    
    return articles.map((chunk, idx)=>{
        return (
            <div className={`${styles.col} col-${idx + 1}`}>
                {chunk.map((a, jdx)=>{
                  var layout = "vertical";
                  var oneline = false;
                  var summary = a.summary;
                  // if(idx === 0 && jdx === 0){
                  //   oneline = true;
                  // }
                  if(idx === 1){
                    layout = "inline";
                  }
                  if(idx === 1){
                    summary = null;
                  }
                    return (
                      <div className={`${styles.articleCard} articleCard`}>
                        <DynamicCard
                          headline={a.headline ? a.headline : null}
                          thumbnail={a.thumbnail ? a.thumbnail : null}
                          date={a.date ? a.date : null}
                          summary={summary ? summary : null}
                          //summary={a.summary ? a.summary : null}
                          tags={a.tags ? a.tags: null}
                          author={a.author ? a.author: null}
                          layout={layout}
                          oneline={oneline}
                        />
                        </div> 
                    );
                })}
            </div>
        )
    })
}

export default Col2FiftyFifty;
